import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["input", "list", "summary"];

  connect() {
    this.render();
  }

  changed() {
    this.render();
  }

  render() {
    const files = Array.from(this.inputTarget.files || []);

    if (this.hasSummaryTarget) {
      if (files.length === 0) {
        this.summaryTarget.textContent = "";
        this.summaryTarget.classList.add("d-none");
      } else {
        const noun = files.length === 1 ? "file" : "files";
        this.summaryTarget.textContent = `${files.length} ${noun} selected`;
        this.summaryTarget.classList.remove("d-none");
      }
    }

    if (!this.hasListTarget) return;

    if (files.length === 0) {
      this.listTarget.innerHTML = "";
      this.listTarget.classList.add("d-none");
      return;
    }

    this.listTarget.classList.remove("d-none");
    this.listTarget.innerHTML = "";
    files.forEach((file) => {
      const item = document.createElement("li");
      item.textContent = file.name;
      this.listTarget.appendChild(item);
    });
  }
}
